<template>
  <!-- modal cadastro -->
  <b-modal id="modal-associar-video" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Associar Vídeos ({{ tipoVideo }}) a lição</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-associar-video')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <template class="modal-body">
      <form>
        <h6><i class="fas fa-user-tag"></i> Adicionar os vídeos em:</h6>
        <div class="row">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <label for="fonte">Curso</label>
              <form-group id="curso" label="curso" label-class="sr-only" :text="{ required: 'Obrigatório selecionar o curso' }" :field="$v.ementa.curso">
                <select class="form-control" v-model="ementa.curso">
                  <option v-if="cursos.length == 0" value="">Carregando...</option>
                  <option v-if="cursos.length > 0" value="">Selecione</option>
                  <option v-for="curso in cursos" :key="curso.id" :value="curso.id">{{ curso.curso }}</option>
                </select>
              </form-group>
            </div>
          </div>

          <div class="col-12 col-md-12" v-if="modulos.length > 0 && ementa.curso">
            <div class="form-group">
              <label for="fonte">Módulo</label>
              <form-group id="curso" label="curso" label-class="sr-only" :text="{ required: 'Obrigatório selecionar o módulo' }" :field="$v.ementa.modulo">
                <select class="form-control" v-model="ementa.modulo">
                  <option value="">Selecione</option>
                  <option v-for="modulo in modulos" :key="modulo.id" :value="modulo.id">{{ modulo.modulo }}</option>
                </select>
              </form-group>
            </div>
          </div>

          <div class="col-12 col-md-12" v-if="licoes.length > 0 && ementa.modulo">
            <div class="form-group">
              <label for="fonte">Lição</label>
              <form-group id="curso" label="curso" label-class="sr-only" :text="{ required: 'Obrigatório selecionar a lição' }" :field="$v.ementa.licao">
                <select class="form-control" v-model="ementa.licao">
                  <option value="">Selecione</option>
                  <option v-for="licao in licoes" :key="licao.id" :value="licao.id">{{ licao.licao }}</option>
                </select>
              </form-group>
            </div>
          </div>
        </div>

        <h6>Ordenação</h6>
        <div class="row mb-4 border rounded p-3 lista-draggable" v-if="ementasDaLicao.length > 0">
          <div class="col-md-6 col-6">
            <div class="d-flex align-items-center">
              <i class="fas fa-exclamation-triangle mr-2" style="font-size:2.5rem;"></i>
              Verifique se os tópicos estão na ordem desejada
            </div>
          </div>
          <div class="col-6 col-md-6">
            <div class="d-flex align-items-center float-right">
                Mostrar todos os tópicos
                <div class="custom-control custom-switch status-curso-switch">
                  <b-form-checkbox v-model="exibeAntigas" name="check-button" switch>
                  </b-form-checkbox>
                </div>
            </div>
          </div>
        </div>
        <template>
          <draggable
            :list="novaOrdem"
            class="list-group ementa-lista lista-draggable"
            ghost-class="ghost"
          >
            <div v-for="(topico, index) in novaOrdem" class="row" v-bind:key="index + 'video'">
              <div class="col-12 col-md-12">
                <div class="form-group" v-if="topico.nova">
                  <div class="item nova border rounded p-3 d-flex align-items-center">
                    <div class="d-flex align-items-center flex-column mr-3">
                      <i class="fas fa-caret-up"></i>
                      <i class="fas fa-caret-down"></i>
                    </div>
                    <i class="fas fa-video mr-2"></i> {{ topico.video }}
                  </div>
                </div>
                <div class="form-group" v-if="!topico.nova && exibeAntigas && topico.tipo_topico_id !== 7">
                  <div class="item antiga border rounded p-3 d-flex align-items-center">
                    <div class="d-flex align-items-center flex-column mr-3">
                      <i class="fas fa-caret-up"></i>
                      <i class="fas fa-caret-down"></i>
                    </div>
                    <i class="fas fa-video mr-2" v-if="topico.tipo_topico_id === 1"></i>
                    <i class="fas fa-align-left mr-2" v-if="topico.tipo_topico_id === 2"></i>
                    <i class="fas fa-image mr-2" v-if="topico.tipo_topico_id === 3"></i>
                    <i class="fas fa-list-ul mr-2" v-if="topico.tipo_topico_id === 4"></i>
                    <i class="fas fa-pencil-alt mr-2" v-if="topico.tipo_topico_id === 5"></i>
                    <i class="fas fa-book mr-2" v-if="topico.tipo_topico_id === 6"></i>
                    {{ topico.video }}
                  </div>
                </div>
              </div>
            </div>
          </draggable>
        </template>
        <div class="text-center">
          <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
            <button class="btn btn-primary mr-3" type="button" @click="associarVideos" >Associar vídeos</button>
            <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-associar-video')">Cancelar</a>
          </div>
        </div>
      </form>
    </template>
  </b-modal>
</template>

<script>
import EmentaAPI from '@/api/ementa-api'
import Swal from 'sweetalert2'
import draggable from 'vuedraggable'
import ResponseUtils from '@/core/util/response-utils'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'

export default {
  name: 'modalAssociaVideo',
  components: { FormGroup, draggable },
  props: {
    videosSelecionadas: Array,
    cursos: Array,
    professores: Array,
    tipoVideo: String
  },
  data () {
    return {
      ordemVideo: '',
      videosBase: [],
      ementasDoCurso: [],
      ementasDoModulo: [],
      ementasDaLicao: [],
      novaOrdem: [],
      exibeAntigas: false,
      ementa: {
        curso: '',
        modulo: '',
        licao: '',
        tipo_topico_id: 1,
        videos: [],
        coordenador: '',
        professor: ''
      }
    }
  },

  watch: {
    videosSelecionadas () {
      this.videosBase = this.videosSelecionadas
    },

    'ementa.curso' () {
      this.ementa.modulo = ''
      this.ementa.licao = ''
      this.ementasDaLicao = []
      EmentaAPI.listar('', this.ementa).then(data => {
        this.ementasDoCurso = data
      })
    },

    'ementa.modulo' () {
      this.ementa.licao = ''
      this.ementasDaLicao = []
      this.ementa.curso &&
      EmentaAPI.listar('', this.ementa).then(data => {
        this.ementasDoModulo = data
      })
    },

    'ementa.licao' () {
      this.ementa.curso &&
      this.ementa.modulo &&
      EmentaAPI.listar('', this.ementa).then(data => {
        this.ementasDaLicao = data
      })
    },

    topicosLicao () {
      this.novaOrdem = this.topicosLicao
    }

  },

  computed: {
    videos: function () {
      return this.novaOrdem
    },

    videosInput: function () {
      let retorno = []
      this.videos.map(video => {
        retorno.push({
          video: video.video,
          vimeo: video.vimeo,
          duration: video.duration,
          videoId: video.videoId,
          ementaId: video.ementaId,
          videoNova: video.nova,
          coordenador: video.coordenador,
          professor: video.professor,
          tipoVideo: this.tipoVideo
        })
      })
      return retorno
    },

    licoes: function () {
      let licoesId = []
      let licoes = []
      this.ementasDoModulo.map(item => {
        if (!licoesId.includes(item.licao.id)) {
          licoesId.push(item.licao.id)
          licoes.push(item.licao)
        }
      })
      return licoes
    },

    modulos: function () {
      let modulosId = []
      let modulos = []
      this.ementasDoCurso.map(item => {
        if (!modulosId.includes(item.modulo.id)) {
          modulosId.push(item.modulo.id)
          modulos.push(item.modulo)
        }
      })
      return modulos
    },

    topicosLicao: function () {
      let videos = []
      this.ementa.licao &&
      this.ementasDaLicao &&
      this.ementasDaLicao.map(ementa => {
        let videoAntiga = {
          video: ementa.topico.topico,
          tipo_topico_id: ementa.topico.tipo_topico_id,
          ementaId: ementa.id,
          nova: false
        }
        videos.push(videoAntiga)
      })
      this.videosBase.map(video => {
        let newVideo = {
          video: (video.video && video.video) || (video.name && video.name),
          videoId: (video.id && video.id) || null,
          vimeo: (video.uri && video.uri.split('/')[2]) || null,
          duration: (video.duration && video.duration) || null,
          professor: (video.professor && video.professor) || null,
          coordenador: (video.coordenador && video.coordenador) || null,
          nova: true,
          ementaId: null
        }
        videos.push(newVideo)
      })
      return videos
    }

  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.ementa = {
        curso: '',
        modulo: '',
        licao: '',
        professor: '',
        coordenador: '',
        tipo_topico_id: 1,
        videos: []
      }
    })
    this.videosBase = this.videosSelecionadas
  },

  validations: {
    ementa: {
      curso: { required },
      modulo: { required },
      licao: { required }
    },
    responsaveis: {
      coordenador: { required },
      professor: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-associar-video')
    },

    associarVideos: function () {
      this.$v.ementa.$touch()
      if (this.tipoVideo !== 'interno') {
        this.$v.responsaveis.$touch()
      }
      if (!this.$v.ementa.$invalid) {
        this.ementa.videos = this.videosInput
        const loader = this.$loading.show()

        EmentaAPI.associarVideos(this.ementa).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Videos associados com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-associar-video')
            this.$emit('videosAssociadas', this.ementa)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
